import dayjs from 'dayjs';
import _ from 'lodash';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import { useTranslation } from 'react-i18next';
import { BsXDiamondFill } from 'react-icons/bs';
import { createUseStyles } from 'react-jss';
import { useShake } from '../../hooks/use-shake';
import { useStorage } from '../../hooks/use-storage';
import { useErrorModal } from '../../screens/error-modal';
import { layoutDefaults } from '../../utils/layout-defaults';
import { parsePayableOrders } from '../../utils/manager/order-manager';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { useCheckoutWorkflow } from '../../workflow/checkout-workflow';

function PaymentButton({
  updateOrders,
  selectedOrders,
  updating,
  setUpdating,
  onSelectInstructions,
}) {
  // const { menuSlug } = useParams();
  const { analyticsPageView } = useAnalytics();
  const {
    // user,
    // userRef,
    payment,
    // setPayment,
    paying,
    // payingRef,
    orders,
    spotRef,
  } = useStorage();
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [loadingPayment, setLoadingPayment] = useState(false);
  // const { preparePaymentSelectAmmountModal, showPaymentSelectAmmountModal } =
  //   usePaymentSelectAmountModal();
  // const showPixPaymentConfirmedModal = usePaymentConfirmedModal();
  // const showPixPaymentCancelledModal = usePaymentCancelledModal();
  // const { prepareOAuthModal, showOAuthModal } = useOAuthModal();
  const { prepareCheckoutWorkflow, showCheckoutWorkflow } =
    useCheckoutWorkflow();
  // const storage = useStorage();
  // const { swal } = useSwal({ storage });

  // const { showPaymentPixQRCodeModal } = usePaymentPixQRCodeModal();
  // const { showSelectCardModal } = useSelectPaymentCardModal();
  const { showErrorModal } = useErrorModal();
  // const { refreshPaymentPixStatusFromRemote } = usePaymentPixAPI();
  // const { loadPaymentFromRemote } = usePaymentAPI();
  const classes = useStyles();

  const buttonRef = useRef();
  // const loadedRef = useRef(false);
  // const cancelledModalShownRef = useRef(false);
  // const confirmedModalShownRef = useRef(false);

  // useEffect(() => {
  //   if (loadedRef.current) return;
  //   loadedRef.current = true;

  //   _.delay(async () => {
  //     const userOrders = filterByUser(orders, user).filter(
  //       (o) => isPayable(o) && o.session?.expires_at == null
  //     );

  //     await wait(layoutDefaults.keyboardDuration);

  //     if (spotRef.current?.prepaid && !_.isEmpty(userOrders)) {
  //       await goToPaymentModal();
  //       analyticsPageView('Bill');
  //     }
  //   }, 100);
  // }, []);

  const payableOrders = useMemo(() => parsePayableOrders(orders), [orders]);

  function isRecentPayment(pPayment) {
    return dayjs(pPayment.confirmed_at).add(4, 'hours').isAfter(dayjs());
  }

  useShake(
    {
      element: buttonRef?.current,
      enabled: updating && !_.isEmpty(payableOrders) && !loadingPayment,
    },
    [updating, payableOrders, loadingPayment]
  );

  useEffect(() => {
    async function checkPendentPayment() {
      if (
        payment?.status === 'paying' &&
        (payment?.expires_at == null || dayjs(payment.expires_at).isAfter())
      ) {
        if (payment.confirmed_at == null || isRecentPayment(payment)) {
          if (payment.card != null) {
            // TODO: removido temporariamente;
            // await showSelectCardModal({ payment });
          } else {
            // TODO: removido temporariamente;
            //  await showPaymentPixQRCodeModal({ payment });
          }

          analyticsPageView('Bill');
        } else {
          await updateOrders();
        }
      }
    }

    checkPendentPayment();
  }, [payment]);

  const hasPendentSelectedOrders = useMemo(
    () =>
      _.isEmpty(selectedOrders.filter((o) => o.session?.expires_at == null)),
    [selectedOrders]
  );

  // useEffect(() => {
  //   if (setUpdating != null) setUpdating(!paying);
  // }, [paying, setUpdating]);

  const goToPaymentModal = async () => {
    if (paying) return;

    setUpdating(false);
    setLoadingPayment(true);
    setLoading(true);

    try {
      await prepareCheckoutWorkflow({
        selectedOrders,
        updateOrders,
      });
      _.delay(() => setLoading(false), layoutDefaults.keyboardDuration);
      const result = await showCheckoutWorkflow();

      if (result?.showSelectInstructions === true) onSelectInstructions();
    } catch (error) {
      // setLoadingPayment(false);
      await showErrorModal(error);
    }

    // if (userRef.current == null) {
    //   await prepareOAuthModal();
    //   await showOAuthModal({ showName: false });
    // }

    // if (userRef.current != null) {
    //   await selectPixAmmount();
    // }

    setLoading(false);
    setUpdating(true);
    setLoadingPayment(false);
  };

  return (
    <Button
      ref={buttonRef}
      className={classes.container}
      size="md"
      // block
      onClick={goToPaymentModal}
    >
      {loading ? (
        <Spinner animation="border" />
      ) : (
        <>
          <BsXDiamondFill />{' '}
          {spotRef.current?.prepaid &&
          (_.isEmpty(selectedOrders) || !hasPendentSelectedOrders)
            ? t('payment-button.pay-and-send')
            : t('payment-button.pay-the-bill')}
        </>
      )}
    </Button>
  );
}

const useStyles = createUseStyles({
  container: {
    // border: '1px solid white',
  },
});

export { PaymentButton };
